import React, { useEffect, useState } from "react";
import "./Auth.css";
import CssBaseline from "@mui/material/CssBaseline";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Footer from "../../components/footer/Footer";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import SignIn from "../../components/Auth/SignIn";
import SignUp from "../../components/Auth/SignUp";
import { useNavigate } from "react-router-dom";
import { getAuth } from "firebase/auth";

function Auth() {
    const [key, setKey] = useState("login");

    const navigate = useNavigate();
    const auth = getAuth();

    useEffect(() => {
        auth.onAuthStateChanged((user) => {
            if (user) {
                navigate("/profile");
            }
        });
    }, [auth, navigate]);

    return (
        <>
            <Grid container component="main" sx={{ height: "100vh" }}>
                <CssBaseline />
                <Grid
                    item
                    xs={false}
                    sm={4}
                    md={7}
                    sx={{
                        backgroundImage:
                            "url(https://source.unsplash.com/random?wallpapers)",
                        backgroundRepeat: "no-repeat",
                        backgroundColor: (t) =>
                            t.palette.mode === "light"
                                ? t.palette.grey[50]
                                : t.palette.grey[900],
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                    }}
                />
                <Grid
                    item
                    xs={12}
                    sm={8}
                    md={5}
                    component={Paper}
                    elevation={6}
                    square
                >
                    <Box
                        sx={{ width: "100%", typography: "body1", padding: 10 }}
                    >
                        <Tabs
                            id="controlled-tab-example"
                            activeKey={key}
                            onSelect={(k) => setKey(k)}
                            className="mb-3 TabsHeader"
                            fill
                        >
                            <Tab
                                className="letters login"
                                eventKey="login"
                                title="Login"
                            >
                                <SignIn />
                            </Tab>
                            <Tab
                                eventKey="signup"
                                title="SignUp"
                                className="signup"
                            >
                                <SignUp />
                            </Tab>
                        </Tabs>
                    </Box>
                </Grid>
            </Grid>
            <Footer />
        </>
    );
}

export default Auth;
